import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import api from '../api/api';

const VerifyEmail = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('Verifying your email...');
  const [error, setError] = useState('');

  useEffect(() => {
    const verify = async () => {
      try {
        const response = await api.post(`/auth/verify-email/${token}`);
        setStatus(response.data?.message || 'Email verified successfully.');
        setTimeout(() => {
          navigate('/login', { state: { message: response.data?.message || 'Email verified successfully. Please login.' } });
        }, 1500);
      } catch (err) {
        setError(err.response?.data?.error || 'Failed to verify email');
      }
    };

    verify();
  }, [token, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-black to-black">
      <div className="bg-white p-8 rounded-lg shadow-2xl w-full max-w-md text-center">
        <h1 className="text-3xl font-bold mb-3 text-gray-800">RankMySkills</h1>
        {!error ? (
          <>
            <h2 className="text-xl font-semibold text-gray-700 mb-4">Email Verification</h2>
            <p className="text-gray-600">{status}</p>
          </>
        ) : (
          <>
            <h2 className="text-xl font-semibold text-red-700 mb-4">Verification Failed</h2>
            <p className="text-red-600 mb-6">{error}</p>
            <Link to="/login" className="text-blue-500 hover:underline font-medium">
              Back to Login
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;
